import type { FeatureFlags, TenantKey } from './types'

// TODO: carry it to redux, or carry to backend and make it a Permission Manager
export const FEATURE_MATRIX: Record<TenantKey, FeatureFlags> = {
  blankstreet: {
    dashboard: false,
    // clarity
    claritySales: false,
    clarityLabor: false,
    claritySpend: true,
    claritySpeedOfService: false,
    clarityLoyalty: false,
    clarityProfitAndLoss: true,
    // clarity lens
    clarityLensSales: false,
    clarityLensSpend: true,
    clarityLensLabor: false,
    clarityLensProfitAndLoss: false,
    // targets
    targetsKpiPayout: true,
    targetsGoalPlans: true,
    // scalr base
    scalrBaseProductMix: false,
    scalrBaseIngredients: false,
    scalrBaseMasterLabor: true,
    // core suite
    coreSuiteBankLines: false,
  },
  dev: {
    dashboard: true,
    // clarity
    claritySales: true,
    clarityLabor: true,
    claritySpend: true,
    claritySpeedOfService: true,
    clarityLoyalty: true,
    clarityProfitAndLoss: false,
    // clarity lens
    clarityLensSales: true,
    clarityLensSpend: false,
    clarityLensLabor: false,
    clarityLensProfitAndLoss: false,
    // targets
    targetsKpiPayout: true,
    targetsGoalPlans: true,
    // scalr base
    scalrBaseProductMix: false,
    scalrBaseIngredients: false,
    scalrBaseMasterLabor: true,
    // core suite
    coreSuiteBankLines: false,
  },
}
